<template>
  <div class="loading-screen-container">
    <div class="background" />
    <div class="inner-loading">
      <ProgressLoading />

      <content v-if="header || message">
        <header>{{ header }}</header>
        <footer>{{ message }}</footer>
      </content>
    </div>
  </div>
</template>

<script>
import ProgressLoading from '@/components/ProgressLoading';

export default {
  components: {
    ProgressLoading,
  },

  props: {
    header: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },  
};
</script>

<style scoped lang="scss">
.loading-screen-container {
  .background {
    position: absolute;

    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    background: $notBlack;

    opacity: 0.7;
    z-index: 10000;
  }

  .inner-loading {
    position: absolute;
    z-index: 10010;
    color: $notBlack;
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;

    justify-content: center;
    align-items: center;

    content {
      margin-top: 16px;
      display: flex;
      justify-content: center;
      flex-direction: column;

      header {
        margin-top: 16px;
        @include h1;
        color: white;
      }

      footer {
        margin-top: 16px;
      }
    }
  }
}
</style>
